import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaidarshancabs() {



  const cardData =
  {
    keyword: 'Pune to Mumbai Darshan Cab',
    heading: 'Sai Trupti Cabs: Pune to Mumbai Darshan Cab',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Mumbai Darshan cab services, designed to make your inter-city sightseeing journey smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space for your day of exploration. Every trip is managed by a professional, background-verified chauffeur who ensures a punctual pickup in Pune, courteous service, and safe, smooth driving all the way to Mumbai is iconic landmarks. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Pune to Mumbai Darshan convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Mumbai with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most iconic landmark, perched at Apollo Bunder and overlooking the Arabian Sea. Built in 1924 to mark the arrival of King George V and Queen Mary, the grand arch blends Indo-Saracenic architecture with colonial elegance. Tourists arrive by ferry to the nearby island, and many pause here to savour street vendors, sea-breeze, and the timeless view of boats on the water. As dusk falls, the monument glows under lights and the surrounding crowd hums with life. With the nearby Taj Mahal Palace hotel and the city skyline close by, the Gateway symbolises Mumbai’s heritage, welcoming spirit and sea-facing grandeur."
  },
  {
    "title": "Marine Drive (Queen’s Necklace)",
    "description": "Marine Drive is a 3.6 km sweeping boulevard that curls alongside the Arabian Sea and has earned the nickname ‘Queen’s Necklace’ for the strand of lights that gleams like pearls at night. At sunset, locals and tourists gather along the promenade to feel the sea-breeze, watch joggers, or simply sit on the railings and reflect. The art-deco buildings on the opposite side echo an era of architectural elegance. With the waves gently lapping below, and the city’s lights coming alive above, Marine Drive embodies Mumbai’s dual rhythm — calming sea and buzzing metropolis. It’s the perfect place for a scenic drive, a leisure walk or a moment of quiet in the city roar."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "Chhatrapati Shivaji Maharaj Terminus (formerly Victoria Terminus) is a UNESCO World Heritage Site and one of Mumbai’s greatest architectural masterpieces. Completed in 1887, the station blends Victorian-Gothic design and Indian motifs: domes, stained glass, arches, carved stone animals, and grand facades. It remains one of India’s busiest railway hubs, yet every passing train seems to echo centuries of the city’s progress. Standing on the polished stone floor, you feel the rhythm of millions of commuters and the grandeur of a bygone era. CSMT is not just transport — it’s a living monument in Mumbai’s heart."
  },
  {
    "title": "Elephanta Caves",
    "description": "Accessible by a short ferry ride from the Gateway of India, the Elephanta Caves lie on Elephanta Island and are a remarkable heritage destination dating back to the 5th-7th centuries. Carved into basalt rock and dedicated to Lord Shiva, the most renowned sculpture is the three-headed Trimurti symbolising creation, preservation and destruction. Visitors wander through dark chambers, climb steep steps, and emerge to stunning sea views across the island. The journey from Mumbai’s bustle to the island’s quiet hills feels like a time-travel into spirituality and stone-art. Elephanta invites you to slow down, look up and reflect on ancient artistry."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach stretches along Mumbai’s western suburbs and is one of its most loved seaside escapes. As the sun begins to set, families, couples and street-food lovers converge on the sands, enjoying pav-bhaji, bhel puri, golas and the cool sea-breeze. The sounds of waves, laughter, vendors and even planes (arriving at nearby airport) mix into a uniquely Mumbai vibe. With the iconic Bollywood homes nearby and the wide open horizon beyond, Juhu offers a slice of coastal freedom in the city. Whether it’s a morning jog, an evening stroll or a kite in the sky, Juhu Beach is where urban pace and sea calm meet."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah sits majestically on a small islet off Worli, connected to the mainland by a narrow causeway that disappears at high tide — creating a magical impression of the mosque floating on the sea. Built in the 15th century, the white marble shrine honours the Sufi saint Pir Haji Ali Shah Bukhari and draws devotees from many faiths. The rhythmic sound of waves, scent of incense, and call to prayer blend into a spiritual aura that transcends the city’s hustle. A simple walk along the causeway, set against sea-spray and sky, offers one of Mumbai’s most peaceful moments."
  },
  {
    "title": "Colaba Causeway & South Mumbai Heritage Walk",
    "description": "Colaba Causeway is one of Mumbai’s most vibrant shopping and cultural streets, located in the heritage zone of South Mumbai. From fashion stalls, antiques, leather goods and souvenirs to famed cafés like Leopold and Café Mondegar, the area pulses with colour and conversation. Beneath its modern buzz lies colonial-era architecture, narrow alleys, and the legacy of a city shaped by trade and sea. Walking the Causeway at twilight, sipping coffee, browsing goods and absorbing the street-life, you sense the cosmopolitan heart of Mumbai — inclusive, historic, creative."
  },
  {
    "title": "Bandra–Worli Sea Link",
    "description": "The Bandra–Worli Sea Link is a modern engineering marvel spanning the Arabian Sea and linking South Mumbai to the western suburbs. This cable-stayed bridge seems to float above the water at dusk as its lights trace a silver arc across the bay. Driving across it reveals breathtaking skyline views, the sea shimmering below and twin worlds of old and new Mumbai. More than a piece of infrastructure, the Sea Link symbolises the city’s ambition and progress — the connection of tradition and tomorrow. Its sleek design and symbolic presence make it not just a pass-through but a destination in itself."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "Sanjay Gandhi National Park, located within the city’s northern reaches, is a green sanctuary of forest, wildlife and ancient rock-cut caves (Kanheri Caves). The vast reserve offers hiking trails, lush hills, boating, and a contrast to Mumbai’s concrete core. As you walk beneath trees, spotting monkeys and birds, you’re reminded that nature still thrives in the metropolis. The Kanheri caves, carved centuries ago, add archaeology and spirituality to the park. Together they create a refreshing retreat from urban rush and a hidden side of Mumbai many overlook."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Shree Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most revered spiritual sites, dedicated to Lord Ganesha and visited by thousands each day. Built in 1801, its golden dome, the carved Ganesha idol, the queue of pilgrims and ringing bells create an immersive aura of sincerity. The temple’s surrounding area buzzes with energy from flower vendors and thousands of devotees. A visit here brings not just prayers but a sense of community, tradition and calm in bustling Mumbai. Siddhivinayak Temple is where faith meets city rhythm with grace."
  }
],



"services": [
  {
    "name": "Pune to Mumbai Darshan Cabs",
    "description": "Book comfortable Pune to Mumbai Darshan cabs for a safe, hassle-free journey. Choose from AC and non-AC vehicles including Sedans, SUVs, and luxury cars. Travel with experienced drivers familiar with long-distance routes, enjoy flexible pickup and drop points, and benefit from transparent pricing. Perfect for family trips, weekend getaways, group travel, or corporate journeys, with easy online booking, instant confirmation, and 24/7 support ensuring a smooth ride."
  },
  {
    "name": "Pune to Mumbai Darshan Taxi Service",
    "description": "Hire a Pune to Mumbai Darshan taxi for a stress-free and scenic journey. Well-maintained vehicles, courteous drivers, and flexible schedules make it ideal for tourists, business travelers, and families. One-way or round-trip options are available with transparent fare policies."
  },
  {
    "name": "Pune to Mumbai Darshan Car Hire",
    "description": "Rent a car from Pune to Mumbai Darshan for personalized and comfortable travel. Choose from Sedans, SUVs, and luxury vehicles with AC/non-AC options. Benefit from professional drivers, luggage assistance, flexible routes, and safe travel. Ideal for families, groups, or business trips seeking convenience and comfort."
  },
  {
    "name": "AC Cab Pune to Mumbai Darshan",
    "description": "Travel comfortably with AC cab service from Pune to Mumbai Darshan. Enjoy clean, air-conditioned vehicles, skilled drivers, flexible pickup points, and smooth, safe travel. Suitable for families, couples, and solo travelers looking for a relaxed long-distance journey."
  },
  {
    "name": "Non AC Cab Pune to Mumbai Darshan",
    "description": "Affordable non-AC cab service from Pune to Mumbai Darshan for budget-conscious travelers. Reliable drivers, well-maintained cars, and flexible pickup/drop points ensure safe, comfortable, and economical travel over long distances."
  },
  {
    "name": "Innova Cab Pune to Mumbai Darshan",
    "description": "Book spacious and comfortable Innova cabs from Pune to Mumbai Darshan. Ideal for families or groups, featuring AC comfort, ample legroom, luggage space, and experienced drivers. Enjoy smooth travel on highways and city roads for a stress-free journey."
  },
  {
    "name": "Ertiga Cab Pune to Mumbai Darshan",
    "description": "Affordable and convenient group travel with Ertiga cabs from Pune to Mumbai Darshan. AC/non-AC options, comfortable seating, luggage space, and professional drivers ensure a safe and enjoyable ride. Perfect for friends, families, or corporate groups."
  },
  {
    "name": "Luxury Cab Pune to Mumbai Darshan",
    "description": "Travel in style with luxury cab services from Pune to Mumbai Darshan. Premium Sedans and SUVs with elegant interiors, AC service, and professional chauffeurs make it ideal for VIP guests, business executives, or special occasions. Experience comfort, safety, and prestige throughout the journey."
  },
  {
    "name": "Affordable Cab Pune to Mumbai Darshan",
    "description": "Get pocket-friendly Pune to Mumbai Darshan cab services with transparent fares, AC/non-AC options, and professional drivers. Flexible timings, easy booking, and reliable service make it perfect for solo travelers, students, and small families looking for value-for-money travel."
  },
  {
    "name": "Pune to Mumbai Darshan Outstation Cab",
    "description": "Reliable outstation cab service from Pune to Mumbai Darshan ideal for weekend trips, sightseeing, or long stays. Choose from a variety of vehicles, enjoy AC/non-AC comfort, flexible bookings, and safe travel with experienced drivers for a hassle-free interstate journey."
  },
  {
    "name": "Pune to Mumbai Darshan One Way Cab",
    "description": "Book one-way cabs from Pune to Mumbai Darshan at affordable rates. Point-to-point travel, clean vehicles, professional drivers, and flexible pickups make it ideal for travelers heading to Mumbai Darshan without return plans."
  },
  {
    "name": "Pune to Mumbai Darshan Drop Cab",
    "description": "One-way drop cab service from Pune to Mumbai Darshan with flexible timings, AC/non-AC options, and professional drivers. Enjoy a smooth, comfortable ride perfect for single transfers, business trips, or leisure travel."
  },
  {
    "name": "Corporate Cab Pune to Mumbai Darshan",
    "description": "Premium corporate cab hire from Pune to Mumbai Darshan with executive vehicles, professional chauffeurs, and flexible travel schedules. Ideal for conferences, business meetings, client visits, and corporate events, offering comfort, punctuality, and reliability."
  },
  {
    "name": "Wedding Cab Pune to Mumbai Darshan",
    "description": "Elegant wedding cab service from Pune to Mumbai Darshan with luxury interiors, AC comfort, professional drivers, and on-time pickups. Perfect for bride/groom transfers, guest transport, and event logistics with complete reliability and style."
  },
  {
    "name": "Online Cab Booking Pune to Mumbai Darshan",
    "description": "Book your Pune to Mumbai Darshan cab online with instant confirmation, secure payment, and transparent fares. Choose from Sedans, Innova, and Ertiga for a convenient, stress-free journey. Ideal for last-minute travel, weekend trips, or planned travel with complete convenience."
  }
],
"tableData": [
  ["Pune to Mumbai Darshan Cabs", "Pune to Mumbai Darshan Taxi Service"],
  ["Pune to Mumbai Darshan Car Hire", "AC Cab Pune to Mumbai Darshan"],
  ["Non AC Cab Pune to Mumbai Darshan", "Innova Cab Pune to Mumbai Darshan"],
  ["Ertiga Cab Pune to Mumbai Darshan", "Luxury Cab Pune to Mumbai Darshan"],
  ["Affordable Cab Pune to Mumbai Darshan", "Pune to Mumbai Darshan Outstation Cab"],
  ["Pune to Mumbai Darshan One Way Cab", "Pune to Mumbai Darshan Drop Cab"],
  ["Online Cab Booking Pune to Mumbai Darshan", "Corporate Cab Pune to Mumbai Darshan"],
  ["Wedding Cab Pune to Mumbai Darshan", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Mumbai Darshan Cabs",
    "WhyChoosedescription": "Sai Trupti Cabs offers comfortable and convenient cab services from Pune to Mumbai Darshan — ideal for sightseeing, family outings, temple visits, and leisure trips."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Get affordable and transparent fares for Pune to Mumbai Darshan cabs — no hidden charges, no surge pricing, and full value for your money."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and premium cars based on your comfort, group size, and budget for the Pune–Mumbai Darshan route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and trained drivers are familiar with the Pune to Mumbai Darshan route, ensuring a safe, smooth, and punctual journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We offer convenient pickups from anywhere in Pune — airport, home, or office — and drop-offs at your preferred destinations across Mumbai for sightseeing."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "Sai Trupti Cabs maintains clean, sanitized, and well-serviced vehicles to ensure a comfortable and reliable travel experience every time."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our support team is available 24/7 to assist you with booking, travel details, or route information for your Pune to Mumbai Darshan trip."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Mumbai Darshan cab easily via call, WhatsApp, or our website — get instant confirmation and enjoy a stress-free sightseeing journey."
  }
]





























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs offer Pune to Mumbai Darshan cab services?',
    answer: 'Yes, Sai Trupti Cabs provides safe, reliable, and affordable Pune to Mumbai Darshan cab services for one way, round trips, and group or family travel.',
  },
  {
    question: 'How can I book a Pune to Mumbai Darshan cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune to Mumbai Darshan cab through our website, mobile app, or by contacting our 24×7 customer support team for instant booking assistance.',
  },
  {
    question: 'What types of cabs are available for Pune to Mumbai Darshan trips?',
    answer: 'We offer a range of well-maintained vehicles including hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers—ideal for families, groups, and solo travelers.',
  },
  {
    question: 'Are the drivers experienced for Pune to Mumbai Darshan routes?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced with the Pune–Mumbai route, ensuring a comfortable and safe travel experience.',
  },
  {
    question: 'Can I book a cab for sightseeing in Mumbai?',
    answer: 'Of course! Sai Trupti Cabs offers sightseeing packages in Mumbai for attractions like Siddhivinayak Temple, Gateway of India, Marine Drive, Juhu Beach, and Elephanta Caves.',
  },
  {
    question: 'Is the Pune to Mumbai Darshan cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs operates 24×7 Pune to Mumbai Darshan cab services so you can plan your trip anytime according to your convenience.',
  },
  {
    question: 'What are the Pune to Mumbai Darshan cab fares?',
    answer: 'Our Pune to Mumbai Darshan cab fares start from ₹2,500 for sedans and ₹3,200–₹4,000 for SUVs or Innova Crysta, depending on your travel plan and vehicle choice.',
  },
  {
    question: 'What payment options are available for Pune to Mumbai Darshan cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for a seamless and secure transaction experience.',
  },
  {
    question: 'What safety and hygiene measures are followed for Pune to Mumbai Darshan cabs?',
    answer: 'All our cabs are sanitized before each ride, and our drivers follow strict hygiene and safety protocols to ensure a worry-free journey.',
  },
  {
    question: 'Is customer support available during the Pune to Mumbai Darshan cab journey?',
    answer: 'Yes, Sai Trupti Cabs provides round-the-clock customer support to assist you during your Pune to Mumbai Darshan trip.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Kulkarni',
    feedback: 'Our Pune to Mumbai Darshan trip with Sai Trupti Cabs was wonderful. The car was clean, the driver was professional, and the sightseeing schedule was perfect.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Meena Joshi',
    feedback: 'Excellent service for our Mumbai Darshan from Pune. Comfortable cab, courteous driver, and on-time service. Highly recommended!',
    rating: 5,
  },
];




























































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Mumbai Darshan Cab Service",
  "image": "https://saitrupticabs.com/assets/images/pune-to-mumbai-darshan-cab.jpg",
  "description": "Sai Trupti Cabs offers Pune to Mumbai darshan cab service with complete sightseeing packages. Visit Gateway of India, Marine Drive, Siddhivinayak Temple and more with one day Mumbai tour. Book Innova Crysta, Ertiga, sedan and SUV cabs for comfortable travel.",
  "provider": {
    "@type": "Organization",
    "name": "Sai Trupti Cabs",
    "url": "https://saitrupticabs.com"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Pune to Mumbai"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "9050"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2999",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-mumbai-darshan-cab-booking",
    "itemCondition": "https://schema.org/NewCondition"
  }
};





  return (
    <div>
<Helmet>
  <title>Pune to Mumbai Darshan Cab | 1 Day Tour Package ₹2999 | Sai Trupti Cabs</title>

  <meta 
    name="description" 
    content="Book Pune to Mumbai darshan cab package at ₹2999 with Sai Trupti Cabs. 1 day Mumbai sightseeing tour including Gateway of India, Marine Drive & Siddhivinayak. Comfortable AC cabs available." 
  />

  <meta 
    name="keywords" 
    content="pune to mumbai darshan cab, mumbai darshan package from pune, pune to mumbai sightseeing cab, mumbai one day tour cab, pune to mumbai taxi darshan, mumbai tour package cab pune, gateway of india tour cab, siddhivinayak temple cab pune to mumbai, mumbai darshan innova crysta, mumbai darshan ertiga cab, mumbai sightseeing cab booking pune, cheap mumbai darshan cab pune, best cab service mumbai tour, mumbai darshan taxi service" 
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/76.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaidarshancabs;